import script from "./AppCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./AppCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./AppCheckbox.vue?vue&type=style&index=0&id=37c2dd6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37c2dd6f"]])

export default __exports__